const HelpIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4643 13.2082L11.2381 9.48974L11.1786 8H12.8214L12.7619 9.48974L12.5357 13.2082H11.4643ZM12 16C11.7222 16 11.4841 15.9022 11.2857 15.7067C11.0952 15.5034 11 15.2571 11 14.9677C11 14.6706 11.0952 14.4242 11.2857 14.2287C11.4841 14.0332 11.7222 13.9355 12 13.9355C12.2937 13.9355 12.5317 14.0332 12.7143 14.2287C12.9048 14.4242 13 14.6706 13 14.9677C13 15.2571 12.9048 15.5034 12.7143 15.7067C12.5317 15.9022 12.2937 16 12 16Z"
        fill="#A9A9A9"
      />
      <path
        d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12V20H12C7.58172 20 4 16.4183 4 12Z"
        stroke="#A9A9A9"
        strokeWidth="2"
      />
    </svg>
  );
};

export default HelpIcon;
